

import Noticias from "../views/Noticias/Noticias";
import MainPublicaciones from "../views/Publicaciones/MainPublicaciones";
import MainRegistros from "../views/Registros/MainRegistros";
import MainSecciones from "../views/Secciones/MainSecciones";
import MainAcademicos from "../views/Academicos/MainAcademicos";
import MainReportes from "../views/Reportes/MainReportes";

const Directivo = [
  {
    path: "/noticias",
    name: "Noticias",
    icon: "pe-7s-news-paper",
    component: Noticias,
    color:"#424242"
  },
  {
    path: "/publicaciones",
    name: "Publicaciones",
    icon: "pe-7s-check",
    component: MainPublicaciones,
    color:"#424242"
  },
  {
    path: "/secciones",
    name: "Secciones",
    icon: "pe-7s-culture",
    component: MainSecciones,
    color:"#424242"
  },
  {
    path: "/registros",
    name: "Registros",
    icon: "pe-7s-plus",
    component: MainRegistros,
    color:"#424242"
  },
  {
    path: "/academicos",
    name: "Académicos",
    icon: "pe-7s-study",
    component: MainAcademicos,
    color:"#424242"
  },
  {
    path: "/reportes",
    name: "Reportes",
    icon: "pe-7s-print",
    component: MainReportes,
    color:"#424242"
  },
  {
    path: "/Home",
    name: "Inicio",
    icon: "pe-7s-home",
    component: Noticias,
    color:"#424242"
  }
];

export default Directivo;




// WEBPACK FOOTER //
// ./src/routes/Directivo.jsx